import { render } from "./tag-input.vue?vue&type=template&id=3725b48b&scoped=true"
import script from "./tag-input.vue?vue&type=script&lang=js"
export * from "./tag-input.vue?vue&type=script&lang=js"

import "./tag-input.vue?vue&type=style&index=0&id=3725b48b&lang=css&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3725b48b"]])

export default __exports__